export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "https://.";
export const GITHUB_LINK = "https://.";
export const DONATION_LINK = "https://.";
export const GA_ID = "G-XXXXXXXX";
export const BACKEND_URL = "https://c.llou.app/mwb";
